import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import ActionLogs from "./actionLogs/ActionLogs";

function Monthlylogs() {
  const location = useLocation();

  // Check if actionlogs or Priority is active
  const isActiveTab = (path) => location.pathname.includes(path);

  return (
    <div className="bg-white p-3 detailpage">
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item pe-4" role="presentation">
          <Link
            to="actionlogs"
            className={`nav-link ${isActiveTab("actionlogs") ? "active" : ""}`}
          >
            Action Logs
          </Link>
        </li>
        {/* <li className="nav-item pe-4" role="presentation">
          <Link
            to="Priority"
            className={`nav-link ${isActiveTab("Priority") ? "active" : ""}`}
          >
            Priority
          </Link>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <Link
            to="Severity"
            className={`nav-link ${isActiveTab("Severity") ? "active" : ""}`}
          >
            Severity
          </Link>
        </li> */}
      </ul>

      {/* Redirect to actionlogs by default */}
      <Routes>
        <Route path="/" element={<Navigate to="actionlogs" replace />} />
        <Route path="actionlogs" element={<ActionLogs />} />
        {/* <Route path="Priority" element={<PriorityTab />} />
        <Route path="Severity" element={<SeverityTab />} /> */}
      </Routes>
    </div>
  );
}

export default Monthlylogs;
